export const CONSENT_CHANGED_BROADCAST_EVENT = 'consentChanged'
export const TEAM = 'eprivacy'
export const SERVICE = 'consent-banner'
